import React, { useState,useEffect } from "react";
import {storage } from "../../firebase.config";
import {ref,listAll,deleteObject} from "firebase/storage";
import { Link } from "react-router-dom";
import FullPageLoader from '../../utils/loader';
import {useSelector} from 'react-redux';

const Dashboard = () =>{
   const [folderList, setFolderList] = useState([]);
   const [isLoading,setLoading] = useState(false);

   const sortBy  = useSelector((state) => state.changeOrder)
   const listAllUsers = async () => {
    try {
        setLoading(true)
        // Get a reference to the root of your storage bucket
        const rootRef = ref(storage);
        // List all items (files and folders) in the root directory
        const items = await listAll(rootRef);
        // Filter items to get only folders
        const folders = items.prefixes.map((prefix) => prefix.fullPath);
        setLoading(false)
        setFolderList(folders);
    } catch (error) {
        setLoading(false)
        setFolderList([]);
        console.error('Error listing folders:', error.message);
    }
  };

  useEffect(() => {
    listAllUsers();
  },[]);


  
return (
        <div className="container-fluid height-74">
            { isLoading  &&    <FullPageLoader/> }

            <div className="row">
                {
                    folderList.length>0 &&
                        // folderList.sort(sortBy === 'ascending' ? (a, b) => a.localeCompare(b) : (a, b) => b.localeCompare(a)).map((user, index) => {
                            folderList.map((user, index) => {
                                return (
                                    <Link to={`/${user}`} className="col-xl-2 col-md-6 mb-4 text-decoration-none" key={index}>
                                        <div className="card border-left-primary shadow h-100 py-2">
                                            <div className="card-body">
                                                <img src={require("../../img/folder1.png")}  alt="folder-icon" />
                                                <div className="text-xs font-weight-bold text-primary text-uppercase mb-1"> {user}</div>
                                                {/* <div className="h5 mb-0 font-weight-bold text-gray-800">{item}</div> */}
                                            </div>
                                        </div>
                                    </Link>
                                )
                            })
                }
            </div>

            {
                folderList.length === 0 && !isLoading &&
                    <div  className="no-data-center" >
                           <div className="no-data-center-font"> No folder </div>
                    </div>
            }
          
        </div>
    )
}

export default Dashboard;
